import {
    GETWITHDRAWLIMITLIST_SUCCESS,
    GETWITHDRAWLIMITLIST_FAILED,
    RESET_GETWITHDRAWLIMITLIST,
    LOADING_GETWITHDRAWLIMITLIST,
    NETWORK_ERROR_GETWITHDRAWLIMITLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetWithdrawLimitList = () => {
    return { type: RESET_GETWITHDRAWLIMITLIST };
};

const getWithdrawLimitList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETWITHDRAWLIMITLIST });
    await partnerServices
        .post("getWithDrawLimitList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getWithdrawLimitListsuccess(res.data));
                    break;
                default:
                    dispatch(getWithdrawLimitListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETWITHDRAWLIMITLIST, payload: err });
        });
};
function getWithdrawLimitListsuccess(data) {
    return {
        type: GETWITHDRAWLIMITLIST_SUCCESS,
        payload: data,
    };
}
function getWithdrawLimitListFailed(data) {
    return {
        type: GETWITHDRAWLIMITLIST_FAILED,
        payload: data,
    };
}

export { resetGetWithdrawLimitList, getWithdrawLimitList };
